import { Table, TableCell } from '@mui/material';
import { TableHead } from '@mui/material';
import { TableBody } from '@mui/material';
import { TableRow } from '@mui/material';
import { Cell, Column, HeaderGroup, Row, useTable } from 'react-table';
import { useTheme } from '@mui/material/styles';
import { sizeByBreakpoint } from '../../utils/helper';

interface TableProps {
  columns: Column<any>[];
  data: any[];
  //   updateData: (rowIndex: number, columnId: string, value: string) => void;
  //   skipPageReset: boolean;
}

function EditableTable({ columns, data }: TableProps) {
  const theme = useTheme();
  //   const defaultColumn = useMemo(
  //     () => ({
  //       Cell: RowEdit
  //     }),
  //     [data]
  //   );

  //   const [editableRowIndex, setEditableRowIndex] = useState(null);

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = useTable(
    {
      columns: columns as readonly Column<any>[],
      data
      //   defaultColumn: defaultColumn,
      //@ts-ignore
      //   updateData
      //   editableRowIndex,
      //   setEditableRowIndex
    },
    // useFilters,
    // useRowSelect,
    (hooks) => {
      hooks.allColumns.push((columns) => [
        ...columns
        // {
        //   accessor: 'edit',
        //   id: 'edit',
        //   Header: 'edit',
        //   Cell: ({ row, setEditableRowIndex, editableRowIndex }: any) => (
        //     <>
        //       <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
        //         <Tooltip title={editableRowIndex !== row.index ? 'Edit' : 'Save'}>
        //           <IconButton
        //             color={editableRowIndex !== row.index ? 'primary' : 'success'}
        //             onClick={() => {
        //               const currentIndex = row.index;
        //               if (editableRowIndex !== currentIndex) {
        //                 // row requested for edit access
        //                 setEditableRowIndex(currentIndex);
        //               } else {
        //                 // request for saving the updated row
        //                 setEditableRowIndex(null);
        //               }
        //             }}
        //           >
        //             {editableRowIndex !== row.index ? <EditTwoTone /> : <SendOutlined />}
        //           </IconButton>
        //         </Tooltip>
        //       </Stack>
        //     </>
        //   )
        // }
      ]);
    }
  );

  // V2 Styles
  const tableHeaderStyles = {
    paddingX: sizeByBreakpoint(1, 16),
    paddingY: sizeByBreakpoint(0.75, 12),
    fontSize: sizeByBreakpoint(1, 13),
    fontWeight: 600,
    color: '#6B7580',
    lineHeight: '20px',
    border: 'none !important',
    backgroundColor: 'transparent !important',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    textAlign: 'center'
  };

  const tableCellStyles = {
    paddingX: sizeByBreakpoint(1, 12),
    paddingY: sizeByBreakpoint(0.75, 10),
    fontSize: sizeByBreakpoint(1, 14),
    fontWeight: 500,
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: `${theme.palette.border.main} !important`,
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.background.default,
    textAlign: 'center'
  };

  return (
    <Table {...getTableProps()} sx={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
      <TableHead sx={{ backgroundColor: 'transparent !important' }}>
        {headerGroups.map((headerGroup) => (
          <TableRow {...headerGroup.getHeaderGroupProps()} sx={{ backgroundColor: 'transparent !important' }}>
            {headerGroup.headers.map((column: HeaderGroup, idx: number) => (
              <TableCell 
                {...column.getHeaderProps()} 
                sx={{
                  ...tableHeaderStyles,
                  ...(idx === 0 && { pl: 3 }),
                  ...(idx === headerGroup.headers.length - 1 && { pr: 3 })
                }}
              >
                {column.render('Header')}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableHead>
      <TableBody {...getTableBodyProps()}>
        {rows.map((row: Row, rowIdx: number) => {
          prepareRow(row);
          const isFirstRow = rowIdx === 0;
          return (
            <TableRow 
              {...row.getRowProps()}
              sx={{
                backgroundColor: isFirstRow 
                  ? `${theme.palette.mode === 'dark' ? 'rgba(0, 105, 92, 0.15)' : 'rgba(0, 105, 92, 0.08)'} !important`
                  : 'transparent',
                '&:hover': {
                  backgroundColor: theme.palette.mode === 'dark' 
                    ? 'rgba(31, 32, 34, 0.2) !important' 
                    : 'rgba(229, 243, 241, 0.6) !important'
                }
              }}
            >
              {row.cells.map((cell: Cell, idx: number) => {
                const isFirst = idx === 0;
                const isLast = idx === row.cells.length - 1;
                return (
                  <TableCell 
                    {...cell.getCellProps()}
                    sx={{
                      ...tableCellStyles,
                      backgroundColor: isFirstRow 
                        ? `${theme.palette.mode === 'dark' ? 'rgba(0, 105, 92, 0.15)' : 'rgba(0, 105, 92, 0.08)'} !important`
                        : theme.palette.background.default,
                      borderLeft: isFirst ? '1px solid' : 'none',
                      borderRight: isLast ? '1px solid' : 'none',
                      borderTopLeftRadius: isFirst ? '8px' : 0,
                      borderBottomLeftRadius: isFirst ? '8px' : 0,
                      borderTopRightRadius: isLast ? '8px' : 0,
                      borderBottomRightRadius: isLast ? '8px' : 0,
                      ...(isFirst && { pl: 3 }),
                      ...(isLast && { pr: 3 })
                    }}
                  >
                    {cell.render('Cell')}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default EditableTable;
